/**
 * withPages
 * HOC for wrapping the provided component with PagesProvider
 */

import React from 'react'
import PagesProvider from './pages-provider'

export default function withPages(WrappedComponent) {
  return function PagesProviderHOC(props) {
    return (
      <PagesProvider>
        <WrappedComponent {...props} />
      </PagesProvider>
    )
  }
};
